import {
  TComponentValue,
} from './openapi-type';

import {
  TFindMetadataResponse,
} from '@/generated/qmulus/axios/core.ts';
import {
  components,
} from '@/generated/qmulus/openapi.ts';

export enum EDataFormat {
  TIME_SERIES = 'time_series',
  JOB_AGGREGATE = 'job_aggregate',
  EVENT = 'event',
  ALARM_EVENT = 'alarm_event',
  BLOB = 'blob',
}

export const DataFormatMap: Record<components['schemas']['DataFormat'], keyof typeof EDataFormat> = {
  time_series: 'TIME_SERIES',
  job_aggregate: 'JOB_AGGREGATE',
  event: 'EVENT',
  alarm_event: 'ALARM_EVENT',
  blob: 'BLOB',
};

export type TMetadataWithChartConfigOverride = TFindMetadataResponse[number] & {
  meaningId: components['schemas']['TimeseriesMeaning'],
  // we have to add this property which is inconsistent with backend, which expects another property on update
  significantDigitsOverwrite?: TComponentValue<'MetadataUpdate'>['significantDigitsOverwrite'],
};
